import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4a4e4980 = () => interopDefault(import('..\\pages\\claim-success.vue' /* webpackChunkName: "pages_claim-success" */))
const _294e04ca = () => interopDefault(import('..\\pages\\eligibility.vue' /* webpackChunkName: "pages_eligibility" */))
const _27ace716 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _650c350f = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _27ab5a73 = () => interopDefault(import('..\\pages\\not-eligible.vue' /* webpackChunkName: "pages_not-eligible" */))
const _678c12f2 = () => interopDefault(import('..\\pages\\patient-information.vue' /* webpackChunkName: "pages_patient-information" */))
const _ae26258a = () => interopDefault(import('..\\pages\\print.vue' /* webpackChunkName: "pages_print" */))
const _a226e4d2 = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _c8f3ebae = () => interopDefault(import('..\\pages\\submit-claim.vue' /* webpackChunkName: "pages_submit-claim" */))
const _28a01a11 = () => interopDefault(import('..\\pages\\success.vue' /* webpackChunkName: "pages_success" */))
const _e6e9cb18 = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _4b4c1592 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _4b2fe690 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _4af7888c = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _4adb598a = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _0f403078 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _38326e40 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/claim-success",
    component: _4a4e4980,
    name: "claim-success"
  }, {
    path: "/eligibility",
    component: _294e04ca,
    name: "eligibility"
  }, {
    path: "/error",
    component: _27ace716,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _650c350f,
    name: "have-a-card"
  }, {
    path: "/not-eligible",
    component: _27ab5a73,
    name: "not-eligible"
  }, {
    path: "/patient-information",
    component: _678c12f2,
    name: "patient-information"
  }, {
    path: "/print",
    component: _ae26258a,
    name: "print"
  }, {
    path: "/rejection",
    component: _a226e4d2,
    name: "rejection"
  }, {
    path: "/submit-claim",
    component: _c8f3ebae,
    name: "submit-claim"
  }, {
    path: "/success",
    component: _28a01a11,
    name: "success"
  }, {
    path: "/upload-documents",
    component: _e6e9cb18,
    name: "upload-documents"
  }, {
    path: "/errors/400",
    component: _4b4c1592,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _4b2fe690,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _4af7888c,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _4adb598a,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _0f403078,
    name: "errors-500"
  }, {
    path: "/",
    component: _38326e40,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
